<template>
  <div id="app">
    <HomeView />
    <HomePage />
  </div>
</template>

<script>
import HomeView from './views/HomeView'
import HomePage from './views/homePage'

export default {
  name: 'indexPage',
  components: {
    HomeView,
    HomePage,
  },
  methods: {}
}

</script>

<style lang="less">
</style>
